import LogsExplorer from './components/explorer/LogsExplorer.vue';

export default function registerLogbookVueComponents(app) {
    app.component('logs-explorer', LogsExplorer);
}
